var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.859,
    height: 5.637,
    viewBox: "0 0 9.859 5.637",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    d: "M12465.854,9884.92l4.576,4.576,4.576-4.576",
    transform: "translate(-12465.5 -9884.566)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownMenu);
export default __webpack_public_path__ + "static/media/dropdownMenu.a65ba117.svg";
export { ForwardRef as ReactComponent };